import React from 'react';
import PageHelmet from '@bd/bdcore-pagehelmet';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageIntroBanner from '../../components/PageIntroBanner';
import InsideHeader from '../../components/InsideHeader';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';

function NoRoute() {
  return (
    <div>
      <InsideHeader h1="Page Not Found" />
      <PageHelmet custom title="Page Not Found" />
      <Header />
      <PageIntroBanner h2="404 Error" p={'The page you requested was not found'} />
      <CtaBanner />
      <TestimonialBanner />
      <Footer />
    </div>
  );
}

export default NoRoute;



// WEBPACK FOOTER //
// ./src/pages/NoRoute/index.js